// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".list-with-scroll-overhangs .overhang{background:#f4f4f4;height:24px;position:absolute;width:100%}.list-with-scroll-overhangs .overhang.top-overhang{top:41px;background:linear-gradient(180deg, #f4f4f4 0%, rgba(1, 1, 1, 0) 100%)}.list-with-scroll-overhangs .overhang.bottom-overhang{bottom:0;background:linear-gradient(0deg, #f4f4f4 0%, rgba(1, 1, 1, 0) 100%)}", ""]);
// Exports
module.exports = exports;
